const
// ENV
BASE_URL = exports.BASE_URL = process.env.REACT_APP_BASE_URL,
BASE_URL_V1 = exports.BASE_URL_V1 = process.env.REACT_APP_BASE_URL_V1,
BASE_URL_V2 = exports.BASE_URL_V2 = process.env.REACT_APP_BASE_URL_V2,
BASE_URL_GATEWAY = exports.BASE_URL_GATEWAY = process.env.REACT_APP_BASE_URL_GATEWAY,
BASE_URL_GATEWAY_V1 = exports.BASE_URL_GATEWAY_V1 = process.env.REACT_APP_BASE_URL_GATEWAY_V1,
BASE_URL_GATEWAY_V2 = exports.BASE_URL_GATEWAY_V2 = process.env.REACT_APP_BASE_URL_GATEWAY_V2,

// Auth
LOGIN = exports.LOGIN = `${BASE_URL_V1}/auth`,
CHECK_ACCESS = exports.CHECK_ACCESS = `${BASE_URL_V1}/auth/check-access`,

// Auth endpoints
KEYCLOAK_AUTH = exports.KEYCLOAK_AUTH = `${BASE_URL_V1}/auth/info`,
KEYCLOAK_VERIFY = exports.KEYCLOAK_VERIFY = `${BASE_URL_GATEWAY_V2}/auth/keycloak`,

// One time sign in/up
OT_SIGNIN = exports.OT_SIGNIN = `${BASE_URL_V1}/ot_signin`,

// Payments
PAYMENT_BASE = exports.PAYMENT_BASE = `${BASE_URL_V1}/payment`,
PAYMENT_SINGLE = exports.PAYMENT_SINGLE = `${BASE_URL_V1}/payment/:uuid`,
PAYMENT_REP = exports.PAYMENT_REP = `${BASE_URL_V1}/payment/:uuid/rep`,
PAYMENT_REP_CANCEL = exports.PAYMENT_REP_CANCEL = `${BASE_URL_V1}/payment/:uuid/cancel`,
PAYMENT_CANCEL_NOTIFY = exports.PAYMENT_CANCEL_NOTIFY = `${BASE_URL_V1}/payment/:uuid/cancel/notify`,
PAYMENT_NOTES = exports.PAYMENT_NOTES = `${BASE_URL_V1}/payment/:uuid/note`,

// Invoice
INVOICE_BASE = exports.INVOICE_BASE = `${BASE_URL_V1}/invoice`,
INVOICE_SINGLE = exports.INVOICE_SINGLE = `${BASE_URL_V1}/invoice/:uuid`,
INVOICE_PAYED = exports.INVOICE_PAYED = `${BASE_URL_V1}/invoice/payment`,
INVOICE_FILES = exports.INVOICE_FILES = `${BASE_URL_V1}/invoice/:uuid/attachment`,
INVOICE_NOTE = exports.INVOICE_NOTE = `${BASE_URL_V1}/invoice/quick_collection`,
INVOICE_EXPORT = exports.INVOICE_EXPORT = `${BASE_URL_V1}/download/invoice`,
INVOICE_CONTPAQI = exports.INVOICE_CONTPAQI = `${BASE_URL_V1}/invoice/:uuid/contpaqi`,
INVOICE_NOTES = exports.INVOICE_NOTES = `${BASE_URL_V1}/invoice/:uuid/note`,

// Reminders

// Customer
CUSTOMER_BASE = exports.CUSTOMER_BASE = `${BASE_URL_V1}/customer`,
CUSTOMER_DEBT = exports.CUSTOMER_DEBT = `${BASE_URL_V1}/customer?due=`,//true`,
CUSTOMER_SINGLE = exports.CUSTOMER_SINGLE = `${BASE_URL_V1}/customer/:uuid`,
CUSTOMER_INVOICES = exports.CUSTOMER_INVOICES = `${BASE_URL_V1}/customer/:uuid/invoice`,
CUSTOMER_PAYMENTS = exports.CUSTOMER_PAYMENTS = `${BASE_URL_V1}/customer/:uuid/payment`,
CUSTOMER_CONTRACTS = exports.CUSTOMER_CONTRACTS = `${BASE_URL_V1}/customer/:uuid/contract`,
ACCOUNT_STATEMENT = exports.ACCOUNT_STATEMENT = `${BASE_URL_V1}/account_statement/email`,
ACCOUNT_STATEMENT_SMS = exports.ACCOUNT_STATEMENT_SMS = `${BASE_URL_V1}/account_statement/sms`,
CUSTOMER_EXPORT = exports.CUSTOMER_EXPORT = `${BASE_URL_V1}/download/customer`,
CUSTOMER_IMPORT = exports.CUSTOMER_IMPORT = `${BASE_URL_V1}/import/customer`,
CUSTOMER_ACTIVITY = exports.CUSTOMER_ACTIVITY = `${BASE_URL_V1}/customer/:uuid/activities`,
CUSTOMER_NOTES = exports.CUSTOMER_NOTES = `${BASE_URL_V1}/customer/:uuid/recent_notes`,
CUSTOMER_REMINDERS = exports.CUSTOMER_REMINDERS = `${BASE_URL_V1}/customer/:uuid/sent_reminders`,
UPDATE_CUSTOMER_INFO = exports.UPDATE_CUSTOMER_INFO = `${BASE_URL_GATEWAY_V1}/customer`,

// Settings
COUNTRY_REGION = exports.COUNTRY_REGION = `${BASE_URL_V1}/catalog/country/:region/district`,
PROFILE = exports.PROFILE = `${BASE_URL_V1}/settings/profile`,
TEAM = exports.TEAM = `${BASE_URL_V1}/settings/team`,
USER_SETTINGS = exports.USER_SETTINGS = `${BASE_URL_V1}/settings`,

// Subscription
VALIDATE_COUPON = exports.VALIDATE_COUPON = `${BASE_URL_V1}/team/subscription/coupons`,
BUY_PACKAGES = exports.BUY_PACKAGES = `${BASE_URL_V1}/team/package/:name`,

// Backend
RESET_FREEMIUM = exports.RESET_FREEMIUM = `${BASE_URL_V1}/settings/freemium`,
RESET_COUNTERS = exports.RESET_COUNTERS = `${BASE_URL_V1}/settings/counters`,
BACK_TO_FREE = exports.BACK_TO_FREE = `${BASE_URL_V1}/team/subscription`,
REMOVE_PAYMENT_METHOD = exports.REMOVE_PAYMENT_METHOD = `${BASE_URL_V1}/team/payment_method`,

// DE DUPE
CREATE_PAYMENT_METHOD = exports.CREATE_PAYMENT_METHOD = `${BASE_URL_V1}/team/payment_method`,
SUBSCRIPTION_PAYMENT = exports.SUBSCRIPTION_PAYMENT = `${BASE_URL_V1}/team/payment_method`,

SUBSCRIPTION_ACTIVE = exports.SUBSCRIPTION_ACTIVE = `${BASE_URL_V1}/team/subscription?enabled=true`,
SUBSCRIPTION_TRANSACTIONS = exports.SUBSCRIPTION_TRANSACTIONS = `${BASE_URL_V1}/team/subscription/transaction?page=1`,
SUBSCRIPTION = exports.SUBSCRIPTION = `${BASE_URL_V1}/team/subscription`,

// SUBSCRIPTION V2
SUBSCRIPTION_V2 = exports.SUBSCRIPTION_V2 = `${BASE_URL_V2}/subscriptions`,
SUBSCRIPTION_ACTIVE_V2 = exports.SUBSCRIPTION_ACTIVE_V2 = `${BASE_URL_V2}/subscriptions/current`,

// Stats
TEAM_STATS = exports.TEAM_STATS = `${BASE_URL_V1}/team/stats`,

// Emails
EMAIL_SETTINGS_BASE = exports.EMAIL_SETTINGS_BASE = `${BASE_URL_V1}/settings/template`,
EMAIL_SETTINGS_BY_ID = exports.EMAIL_SETTINGS_BY_ID = `${BASE_URL_V1}/settings/template?type=:templateId`,

// Sms
SMS_SETTINGS_BASE = exports.SMS_SETTINGS_BASE = `${BASE_URL_V1}/settings/template/sms`,
SMS_SETTINGS_BY_ID = exports.SMS_SETTINGS_BY_ID = `${BASE_URL_V1}/settings/template/sms?type=:templateId`,

// Collection
COLLECTION_BASE = exports.COLLECTION_BASE = `${BASE_URL_V1}/settings/collection`,
COLLECTION_SINGLE = exports.COLLECTION_SINGLE = `${BASE_URL_V1}/settings/collection/:uuid`,
INVOICE_SINGLE_COLLECTION = exports.INVOICE_SINGLE_COLLECTION = `${BASE_URL_V1}/invoice/:uuid/collection`,
INVOICE_COLLECTION = exports.INVOICE_COLLECTION = `${BASE_URL_V1}/invoice/:uuid/collection`,
INVOICE_SINGLE_COLLECTION_SMS = exports.INVOICE_SINGLE_COLLECTION_SMS = `${BASE_URL_V1}/invoice/:uuid/collection/sms`,

// Integrations
INTEGRATION = exports.INTEGRATION = `${BASE_URL_V1}/settings/integration`,
VALIDATION_RFC = exports.VALIDATION_RFC = `${BASE_URL_V1}/settings/integration/rfc`,
SAT_INTEGRATION = exports.SAT_INTEGRATION = `${BASE_URL_V1}/settings/integration/1`,
DOWNLOAD_INVOICES = exports.DOWNLOAD_INVOICES = `${BASE_URL_V1}/settings/integration/7`,
SAT_CERTIFICATES = exports.SAT_CERTIFICATES = `${BASE_URL_V1}/settings/integration/certs`,
SAT_INTEGRATION_ERRORS = exports.SAT_INTEGRATION_ERRORS = `${BASE_URL_V1}/team/action`,
PAYMENT_INSTRUCTIONS_INT = exports.PAYMENT_INSTRUCTIONS_INT = `${BASE_URL_V1}/settings/integration/2`,
SPEI_INTEGRATION = exports.SPEI_INTEGRATION = `${BASE_URL_V1}/settings/integration/3`,
SYNC_SAT = exports.SYNC_SAT = `${BASE_URL_V1}/invoice/import/sat`,
STRIPE_INTEGRATION = exports.STRIPE_INTEGRATION = `${BASE_URL_V1}/settings/integration/4`,
CONEKTA_INTEGRATION = exports.CONEKTA_INTEGRATION = `${BASE_URL_V1}/settings/integration/5`,
OXXO_INTEGRATION = exports.OXXO_INTEGRATION = `${BASE_URL_V1}/settings/integration/6`,
RELATION_CONCEPTS = exports.RELATION_CONCEPTS = `${BASE_URL_V1}/payment/contpaqi/relation-concepts`,
SAVE_RELATION_CONCEPTS = exports.SAVE_RELATION_CONCEPTS = `${BASE_URL_V1}/payment/contpaqi/relation-concepts`,
SYNC_CONTPAQI = exports.SYNC_CONTPAQI = `${BASE_URL_V1}/invoice/sync/contpaqi`,

// Reports

// Account
CREATE_ACCOUNT = exports.CREATE_ACCOUNT = `${BASE_URL_V1}/account`,
REQUEST_OTP = exports.REQUEST_OTP = `${BASE_URL_V1}/account/generateOTP`,
CONFIRM_OTP = exports.CONFIRM_OTP = `${BASE_URL_V1}/account/confirmOTP`,
GET_ACCOUNT = exports.GET_ACCOUNT = `${BASE_URL_V1}/account/me/`,
VERIFY_ACCOUNT = exports.VERIFY_ACCOUNT = `${BASE_URL_V1}/account/verification`,
EMAIL_VERIFY_ACCOUNT = exports.EMAIL_VERIFY_ACCOUNT = `${BASE_URL_V1}/account/me/verification`,
CHANGE_PASSWORD = exports.CHANGE_PASSWORD = `${BASE_URL_V1}/account/me/password/change`,
SEND_EMAIL_RECOVER_PASSWORD = exports.SEND_EMAIL_RECOVER_PASSWORD = `${BASE_URL_V1}/account/password/recovery`,
RECOVER_PASSWORD_VERYFY_TOKEN = exports.RECOVER_PASSWORD_VERYFY_TOKEN = `${BASE_URL_V1}/account/password/verify?token=`,
RESTORE_PASSWORD = exports.RESTORE_PASSWORD = `${BASE_URL_V1}/account/password/restore`,
CREATE_NEW_TEAM = exports.CREATE_NEW_TEAM = `${BASE_URL_V1}/account/:uuid/team`,
TEAM_TOKEN = exports.TEAM_TOKEN = `${BASE_URL_V1}/account/me/team_token`,
TEAMS = exports.TEAMS = `${BASE_URL_V1}/account/me/team`,

// Invitations
INVITATIONS = exports.INVITATIONS = `${BASE_URL_V1}/enterprise/:uuid/invite`,
INVITATIONS_USERS = exports.INVITATIONS_USERS = `${BASE_URL_V1}/account/invitation`,
ROLES_USERS = exports.ROLES_USERS = `${BASE_URL_V1}/account/roles`,
CREATE_ROLE = exports.CREATE_ROLE = `${BASE_URL_V1}/account/role`,
DELETE_ROLE = exports.DELETE_ROLE = `${BASE_URL_V1}/account/role/:id`,
UPDATE_ROLE = exports.UPDATE_ROLE = `${BASE_URL_V1}/account/role/:id`,
ROLE_PERMISSIONS = exports.ROLE_PERMISSIONS = `${BASE_URL_V1}/account/role_permissions/:id`,
LOG_INSERT = exports.LOG_INSERT = `${BASE_URL_GATEWAY_V1}/log/insert`,

// Users
USERS = exports.USERS = `${BASE_URL_V1}/account/user`,

// Notifications
GET_TEAM_NOTIFICATIONS = exports.GET_TEAM_NOTIFICATIONS = `${BASE_URL_V1}/team/notification?limit=100`,
UPDATE_TEAM_NOTIFICATIONS = exports.UPDATE_TEAM_NOTIFICATIONS = `${BASE_URL_V1}/team/notification`,

// Product
GET_ALL_PRODUCTS = exports.GET_ALL_PRODUCTS = `${BASE_URL_V1}/item?`,
CREATE_PRODUCT = exports.CREATE_PRODUCT = `${BASE_URL_V1}/item`,
EDIT_PRODUCT = exports.EDIT_PRODUCT = `${BASE_URL_V1}/item/:uuid`,
GET_TAXES = exports.GET_TAXES = `${BASE_URL_V1}/settings/tax?price=:itemPrice`,
ADD_TAX = exports.ADD_TAX = `${BASE_URL_V1}/item/:uuid/tax`,
DELETE_TAX = exports.DELETE_TAX = `${BASE_URL_V1}/item/:uuid/tax/:id`,
GET_SAT_CODES = exports.GET_SAT_CODES = 'https://search.yay.do/search/autocomplete/claveprodserv_satcodes?q=',

// Client Portal
CLIENT_DETAIL = exports.CLIENT_DETAIL = `${BASE_URL_V1}/client/:uuid`,
CLIENT_INVOICES = exports.CLIENT_INVOICES = `${BASE_URL_V1}/client/:uuid/invoice`,
CLIENT_INVOICES_FROM_UUID = exports.CLIENT_INVOICES_FROM_UUID = `${BASE_URL_V1}/client/:uuid/invoices`,
CLIENT_CONTRACTS = exports.CLIENT_CONTRACTS = `${BASE_URL_V1}/client/:uuid/contract`,
CLIENT_PROVIDER = exports.CLIENT_PROVIDER = `${BASE_URL_V1}/client/:uuid/provider`,
CLIENT_RECURRING_PAYMENT = exports.CLIENT_RECURRING_PAYMENT = `${BASE_URL_V1}/client/:uuid/contract/recurring_payment`,
CLIENT_CONFIRM_DOMICILIATION = exports.CLIENT_CONFIRM_DOMICILIATION = `${BASE_URL_V1}/client/:uuid/contact/recurring_payment_request`,
CLIENT_RECURRING_PAYMENT_QUERY = exports.CLIENT_RECURRING_PAYMENT_QUERY = `${BASE_URL_V1}/client/:uuid/contract/recurring_payment`,
CLIENT_SETTINGS = exports.CLIENT_SETTINGS = `${BASE_URL_V1}/clients/:uuid/settings`,
CLIENT_INVOICE_BALANCE = exports.CLIENT_INVOICE_BALANCE = `${BASE_URL_V1}/client/:uuid/invoices?q=:invoice`,
CLIENT_REDIRECT = exports.CLIENT_REDIRECT = `${BASE_URL}/redirect/client/:uuid`,
PAYMENT_INTENT = exports.PAYMENT_INTENT = `${BASE_URL_V1}/pay_intent`,

// OnBoarding
ONBOARDING = exports.ONBOARDING = `${BASE_URL_V1}/team/boarding`,

// ApiKey
API_KEY = exports.API_KEY = `${BASE_URL_V1}/api_key`,

/** CONTRACT */
CREATE_CONTRACT = exports.CREATE_CONTRACT = `${BASE_URL_V1}/contract`,
CONTRACT_BASE = exports.CONTRACT_BASE = `${BASE_URL_V1}/contract`,
ADD_FILES_CONTRACT = exports.ADD_FILES_CONTRACT = `${BASE_URL_V1}/contract/`,
CONTRACT_DETAIL = exports.CONTRACT_DETAIL = `${BASE_URL_V1}/contract/:uuid`,
CONTRACT_EXPORT = exports.CONTRACT_EXPORT = `${BASE_URL_V1}/download/contract`,
PORTAL_CONTRACT = exports.PORTAL_CONTRACT = `${BASE_URL_V1}/client/:uuid/contract/:id`,
CONTRACT_RECURRING_PAYMENT = exports.CONTRACT_RECURRING_PAYMENT = `${BASE_URL_V1}/contract/request_recurring_payment`,
CONTRACT_IMPORT = exports.CONTRACT_IMPORT = `${BASE_URL_V1}/import/contract`,
CONTRACT_FRECUENCY = exports.CONTRACT_FRECUENCY = `${BASE_URL_V1}/contract/:uuid/frecuency/:id`,
CONTRACT_NOTES = exports.CONTRACT_NOTES = `${BASE_URL_V1}/contract/:uuid/note`,
CANCEL_CONTRACT = exports.CANCEL_CONTRACT = `${BASE_URL_V1}/contracts/:uuid/cancel`,
RECURRING_PAYMENT_CONEKTA = exports.RECURRING_PAYMENT_CONEKTA = `${BASE_URL_V1}/client/:uuid/recurring_payment_conekta`,
CATALOG_SOURCE = exports.CATALOG_SOURCE = `${BASE_URL_V1}/catalog_source`,

// Payment request
PAYMENT_REQUEST = exports.PAYMENT_REQUEST = `${BASE_URL_V1}/pay_request/invoice`,
PAY_ORDER = exports.PAY_ORDER = `${BASE_URL_V1}/pay_order/stripe`,
PAY_ORDER_OXXO = exports.PAY_ORDER_OXXO = `${BASE_URL_V1}/pay_order/oxxo`,
PAY_ORDER_SPEI = exports.PAY_ORDER_SPEI = `${BASE_URL_V1}/pay_order/spei`,
PAYMENT_EXPORT = exports.PAYMENT_EXPORT = `${BASE_URL_V1}/download/payment`,
PAYMENT_REFERENCE = exports.PAYMENT_REFERENCE = `${BASE_URL_V1}/payment/reference`,

// Credit Note
CREDIT_NOTE_BASE = exports.CREDIT_NOTE_BASE = `${BASE_URL_V1}/credit_note`,
CREDIT_NOTE_SINGLE = exports.CREDIT_NOTE_SINGLE = `${BASE_URL_V1}/credit_note/:uuid`,
CREDIT_NOTE_NOTES = exports.CREDIT_NOTE_NOTES = `${BASE_URL_V1}/credit_note/:uuid/note`,

// Currency

// Short Urls

// Notes
NOTES_BASE = exports.NOTES_BASE = `${BASE_URL_V1}/note/:uuid`,

// Admin
TEAM_ACCESS = exports.TEAM_ACCESS = `${BASE_URL_V1}/team/access`
ADMIN_LOGIN = exports.ADMIN_LOGIN = `${BASE_URL_GATEWAY}/admin/auth`
ADMIN_RETRIES = exports.ADMIN_RETRIES = `${BASE_URL_GATEWAY}/admin/machine/state`
ADMIN_CATALOGS = exports.ADMIN_CATALOGS = `${BASE_URL_GATEWAY_V1}/catalog`
ADMIN_TEMPLATE_SMS = exports.ADMIN_TEMPLATE_SMS = `${BASE_URL_GATEWAY}/admin/catalog/template_sms`
ADMIN_EDIT_TEMPLATE_SMS = exports.ADMIN_EDIT_TEMPLATE_SMS = `${BASE_URL_GATEWAY}/admin/catalog/template_sms/key/:uuid`,

/** GATEWAY */
CHANGE_CARD = exports.CHANGE_CARD = `${BASE_URL_GATEWAY_V1}/payment/change-card`,
PAYMENT_LINK = exports.PAYMENT_LINK = `${BASE_URL_GATEWAY_V1}/payment/card`,
PAYMENT_SMS = exports.PAYMENT_SMS = `${BASE_URL_GATEWAY_V1}/payment/sms`,
PAYMENT_SMS_MANUAL = exports.PAYMENT_SMS_MANUAL = `${BASE_URL_GATEWAY}/reco/v1/send/sms`,
PAYMENT_EMAIL = exports.PAYMENT_EMAIL = `${BASE_URL_GATEWAY_V1}/payment/email`,
PAYMENT_EMAIL_MANUAL = exports.PAYMENT_EMAIL_MANUAL = `${BASE_URL_GATEWAY}/reco/v1/send/email`,
LOG_INVOICE = exports.LOG_INVOICE = `${BASE_URL_GATEWAY_V1}/log/invoice`,
/** DASHBOARD */
DASHBOARD_CATALOG = exports.DASHBOARD_CATALOG = `${BASE_URL_GATEWAY_V1}/graph/catalogs`,
GRAPH = exports.GRAPH = `${BASE_URL_GATEWAY_V1}/graph`,
GRAPH_STATUS = exports.GRAPH_STATUS = `${BASE_URL_GATEWAY_V1}/graph/statusContracts`,
GRAPH_TOTAL_POLICIES = exports.GRAPH_TOTAL_POLICIES = `${BASE_URL_GATEWAY_V1}/graph/policies_total`,
GRAPH_AMOUNT_POLICIES = exports.GRAPH_AMOUNT_POLICIES = `${BASE_URL_GATEWAY_V1}/graph/policies_amount`,
GRAPH_PAYMENT_METHOD = exports.GRAPH_PAYMENT_METHOD = `${BASE_URL_GATEWAY_V1}/graph/payment-method`,
GRAPH_SENT_LINKS = exports.GRAPH_SENT_LINKS = `${BASE_URL_GATEWAY_V1}/graph/link-send`,
GRAPH_PAYMENT_RENEWALS = exports.GRAPH_PAYMENT_RENEWALS = `${BASE_URL_GATEWAY_V1}/graph/type_payment_renewals`,
GRAPH_APPROVED_REJECTED = exports.GRAPH_APPROVED_REJECTED = `${BASE_URL_GATEWAY_V1}/graph/approved-rejected`,
GRAPH_SUCCESSFUL_PAY = exports.GRAPH_SUCCESSFUL_PAY = `${BASE_URL_GATEWAY_V1}/graph/successful-pay`,
GRAPH_COLLECTION_ATTEMPT = exports.GRAPH_COLLECTION_ATTEMPT = `${BASE_URL_GATEWAY_V1}/graph/collection-attempt`,
GRAPH_REJECTION_TYPE = exports.GRAPH_REJECTION_TYPE = `${BASE_URL_GATEWAY_V1}/graph/rejection_type`,
GRAPH_POLICY_PERIODICITY = exports.GRAPH_POLICY_PERIODICITY = `${BASE_URL_GATEWAY_V1}/graph/policy-periodicity`,
GRAPH_CHANGE_CARD = exports.GRAPH_CHANGE_CARD = `${BASE_URL_GATEWAY_V1}/graph/change-card`

/** AGENTS */
AGENT_BASE = exports.AGENT_BASE = `${BASE_URL_GATEWAY}/reco/v1/agent`
AGENT_COLLECTION_BASE= exports.AGENT_COLLECTION_BASE = `${BASE_URL_GATEWAY_V2}/anonymously`
AGENT_COLLECTION_BASE_CALL= exports.AGENT_COLLECTION_BASE_CALL = `${BASE_URL_GATEWAY_V2}/auth/callcenter`
AGENT_COLLECTION_DATA= exports.AGENT_COLLECTION_DATA = `${BASE_URL_GATEWAY}/payments/v2/agents/:id`
AGENT_CATALOGS_DATA= exports.AGENT_CATALOGS_DATA = `${BASE_URL_GATEWAY}/payments/v2/agents/catalogs`
AGENT_PAYMENT_REQUEST= exports.AGENT_PAYMENT_REQUEST = `${BASE_URL_GATEWAY}/payments/v2/payment_request`
AGENT_CURRENCY= exports.AGENT_CURRENCY = `${BASE_URL_GATEWAY}/payments/v1/currency_rate`
AGENT_REPORT= exports.AGENT_REPORT = `${BASE_URL_GATEWAY}/payments/v2/agents/report/:type`
AGENT_CANCEL_REFERENCES= exports.AGENT_CANCEL_REFERENCES = `${BASE_URL_GATEWAY}/payments/v2/agents/cancel_bank_reference`
AGENT_RECURRING_PAYMENT_REQUEST = exports.AGENT_RECURRING_PAYMENT_REQUEST = `${BASE_URL_GATEWAY}/payments/v2/recurring_payment_request`
AGENT_PAYMENT_METHOD = exports.AGENT_PAYMENT_METHOD = `${BASE_URL_GATEWAY}/payments/v2/agents/recurring_payments`
AGENT_CANCEL_RECURRING_PAYMENT = exports.AGENT_CANCEL_RECURRING_PAYMENT = `${BASE_URL_GATEWAY}/payments/v2/agents/delete_recurring_payment`
AGENT_PAYMENT_RECEIPTS_HISTORY = exports.AGENT_PAYMENT_RECEIPTS_HISTORY = `${BASE_URL_GATEWAY}/v2/payment/receipt`
AGENT_PAYMENT_REPORT_HISTORY = exports.AGENT_PAYMENT_REPORT_HISTORY = `${BASE_URL_GATEWAY}/payments/v2/agents/report/history`

CLIENT_POLICY_CATALOG = exports.CLIENT_POLICY_CATALOG = `${BASE_URL_GATEWAY}/payments/v2/clients/type-policy-catalog`
CLIENT_AUTH = exports.CLIENT_AUTH = `${BASE_URL_GATEWAY}/v2/auth/client`
CLIENT_AUTH_MOBILE = exports.CLIENT_AUTH_MOBILE = `${BASE_URL_GATEWAY}/v2/auth/client-mobile`
CLIENT_RECEIPTS_RFC = exports.CLIENT_RECEIPTS_RFC = `${BASE_URL_GATEWAY}/payments/v2/clients/pending-receipts/by_policy`
CLIENT_RECEIPTS_CUSTOMER = exports.CLIENT_RECEIPTS_CUSTOMER = `${BASE_URL_GATEWAY}/payments/v2/clients/pending-receipts/by_customer`

/*NOTIFICATION */
NOTIFICATION_BASE = exports.NOTIFICATION_BASE = `${BASE_URL_GATEWAY}/reco/v1/notification`;

/** DOMICILIATION PERMISSIONS */
DOMICILIATION_PERMISSIONS_CHECK_SPECIAL = exports.DOMICILIATION_PERMISSIONS_CHECK_SPECIAL = `${BASE_URL_GATEWAY_V1}/domiciliation/permissions/verify-component-domiciliation`,
DOMICILIATION_PERMISSIONS_CLIENTE = exports.DOMICILIATION_PERMISSIONS_CLIENTE = `${BASE_URL_GATEWAY_V1}/domiciliation/permissions/cliente`;




// WEBPACK FOOTER //
// ./src/constants/endpoints.js